export default "__VITE_ASSET__ByZUc3uG__"